import { DocumentItemTypes, DocumentType } from 'scenes/Documents/components/DocumentItem/DocumentItemTypes';

/**
 * Utility function to get the file extension based on the document type, used for documentItem
 * @param {DocumentType} document - The document object containing mimetype and filename.
 * @returns {string} - The file extension or 'file' if no specific type is matched.
 */
export const getFileExtension = (document: DocumentType): DocumentItemTypes | string => {
  if (document.mimetype) {
    if (document.mimetype.includes('pdf')) return 'pdf';
    if (document.mimetype.includes('image')) return 'image';
    if (document.mimetype.includes('video') || document.mimetype.includes('audio')) return 'video';
    return 'file';
  }
  const extention = document.filename?.split('.') || [];
  return extention[extention.length - 1] || 'file';
};
